import React, { Component } from 'react'
import { PulseLoader } from 'halogen'

const styles = {
  display: 'flex',
  height: '20vh',
  width: '100%',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
}

const Splitter = LoadFunction =>
  class Split extends Component {
    constructor() {
      super()
      this.state = {
        Component: null,
        aSync: true,
      }
    }

    componentDidMount = async () => {
      if (!this.state.Component) {
        const { default: Component } = await LoadFunction()
        this.setState({ Component, aSync: false })
      }
    }

    render() {
      const { Component, aSync } = this.state
      if (aSync) {
        return (
          <div style={styles}>
            <PulseLoader color="#00abde" />
          </div>
        )
      } else {
        return <Component {...this.props} />
      }
    }
  }

export default Splitter



// WEBPACK FOOTER //
// ./src/helpers/Splitter.js